
// メールアドレス - reg: メールアドレスの形式 ==================================================
export function validateMail (value) {
// const REG = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
  const REG = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/
  return REG.test(value)
}

// パスワード - reg: 英数組み合わせ6-50文字 ==================================================
export function validatePsw (value) {
  const REG = /^(?=.*?[a-z])[a-z\d]{6,50}$/i
  return REG.test(value)
}



// WEBPACK FOOTER //
// ./src/util/validation.js